module.exports = __webpack_public_path__ + "img/john-de-wolf1.733d5f4b.jpg";